// import shenHe from '@/core/component/shenHe'
export default {
  className: 'wallet',
  perPage: 5,
  mixin: {
    fields: [
      {
        name: 'user',
        render: (record) => {
          if (record && record.user && record.user.nickName) {
            return `${record.user.nickName}`
          }
        },
        width: 120
      },
      'balance'
    ],
    hooks: {
      beforeFetch ({ where }) {
        where.user = {
          $inQuery: {
            where: {
              phone: {
                $exists: true
              }
            },
            className: '_User'
          }
        }
      }
    }
  }
}
